export const environment = {
    production: true,
    hmr: false,
    api_url: 'https://api.ewsg.xcoapp.nl'
};


// WEBPACK FOOTER //
// ./apps/eyewatch/src/environments/environment.ts